import {t} from 'app/translations';
import {EskotValidator} from 'utils/eskot-validator';
import {Errors} from 'utils/validator';

import {ManagementOrganizationFormValues} from '../types/management-organization-form-values';

const te = t('admin');

/**
 * Validates organization-management form values.
 *
 * @param values Organization-management form state.
 * @returns Validation errors keyed by form field.
 */
// eslint-disable-next-line max-lines-per-function
export const managementOrganizationsValidate = (
    values: ManagementOrganizationFormValues,
): Errors<ManagementOrganizationFormValues> => {
    const validator = new EskotValidator(values);
    const approveIsInvalid = (
        values.approvedFrom !== null
        && values.approvedTo !== null
        && values.approvedFrom > values.approvedTo
    );
    const isFarmOrCenterEmpty = (
        (values.farmIds === null || values.farmIds.length === 0)
        && (values.organizationCenterIds === null || values.organizationCenterIds.length === 0)
    );

    validator.nonEmpty('approvedFrom', te('approvedFrom'));
    validator.customRule(
        'farmIds',
        isFarmOrCenterEmpty,
        te('farmsOrCentersMustBeFilled'),
    );
    validator.customRule(
        'organizationCenterIds',
        isFarmOrCenterEmpty,
        te('farmsOrCentersMustBeFilled'),
    );
    validator.customRule(
        'approvedTo',
        approveIsInvalid,
        te('dateFromToIsInvalid'),
    );
    validator.nonEmpty('userProfileId', te('loginName'));
    validator.nonEmpty('roleIds', te('roles'));

    return validator.generateErrorsObject();
};
